import { render, staticRenderFns } from "./UsersGroupsPermissionsDialog.vue?vue&type=template&id=e1aaa8e2&scoped=true&"
import script from "./UsersGroupsPermissionsDialog.vue?vue&type=script&lang=js&"
export * from "./UsersGroupsPermissionsDialog.vue?vue&type=script&lang=js&"
import style0 from "./UsersGroupsPermissionsDialog.vue?vue&type=style&index=0&id=e1aaa8e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1aaa8e2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VList } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VExpansionPanels,VList,VRow,VSpacer})
